import { toast } from 'react-toastify';

import {
  fetchSellOrdersList,
  fetchSellOrdersResume,
  fetchSellOrdersExport,
  fetchSellOrder,
  deleteSellOrder,
  fetchSellOrderNfe,
  requestSendNfe
} from './services';

import {
  setIsLoading,
  setIsModalLoading,
  setSellOrdersResume,
  setSellOrdersList,
  setSellOrder,
  setSellOrderNfNumber,
  setSellOrderHasNfe,
  clearSellOrder
} from './actions';

import { loadStorageHistoryList } from 'pages/StorageHistory/store/thunk';
import { loadStorageHistoryResume } from 'pages/StorageHistory/store/thunk';

import { handleExporting } from 'components/Filter/store/actions';

export const loadSellOrdersList = (userId, establishmentId, extraProps) => dispatch => {
  dispatch(setIsLoading(true));

  const { page, startDate, endDate, qp } = extraProps;

  return fetchSellOrdersList(userId, establishmentId, page, startDate, endDate, qp)
    .then(({ data }) => dispatch(setSellOrdersList(data)))
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadSellOrdersResume = (userId, establishmentId, extraProps) => dispatch => {
  dispatch(setIsLoading(true));

  const { startDate, endDate, qp } = extraProps;

  return fetchSellOrdersResume(userId, establishmentId, startDate, endDate, qp)
    .then(({ data }) => dispatch(setSellOrdersResume(data)))
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadSellOrdersExport = (userId, establishmentId, extraProps) => dispatch => {
  dispatch(handleExporting(true));

  const { startDate, endDate, qp } = extraProps;

  return fetchSellOrdersExport(userId, establishmentId, startDate, endDate, qp)
    .then(({ data }) => data)
    .finally(() => dispatch(handleExporting(false)));
}

export const loadSellOrder = (userId, establishmentId, orderId) => dispatch => {
  dispatch(clearSellOrder());
  dispatch(setIsModalLoading(true));

  return fetchSellOrder(userId, establishmentId, orderId)
    .then(({ data }) => dispatch(setSellOrder(data)))
    .finally(() => dispatch(setIsModalLoading(false)));
}

export const removeSellOrder = (userId, establishmentId, orderId, params, extraProps, pageOrigin) => dispatch => {
  dispatch(setIsModalLoading(true));

  const { storageProductUuid, page } = extraProps;

  return deleteSellOrder(userId, establishmentId, orderId, params)
    .then(() => {
      if(pageOrigin == 'storageHistory') {
        dispatch(loadStorageHistoryList(userId, establishmentId, storageProductUuid, page));
        dispatch(loadStorageHistoryResume(userId, establishmentId, storageProductUuid));
      }

      toast.success('Ordem de venda removida com sucesso.');

      return Promise.resolve();
    })
    .finally(() => dispatch(setIsModalLoading(false)));
}

export const loadSellOrderNfe = (userId, establishmentId, orderId) => dispatch => {
  dispatch(setIsModalLoading(true));

  return fetchSellOrderNfe(userId, establishmentId, orderId)
    .then(({ data }) => {
      dispatch(setSellOrderNfNumber(data?.nfNumber));
      dispatch(setSellOrderHasNfe(true));
      return Promise.resolve(data);
    })
    .catch(() => {
      dispatch(setSellOrderNfNumber(0));
      dispatch(setSellOrderHasNfe(false));
      return Promise.reject({});
    })
    .finally(() => dispatch(setIsModalLoading(false)));
}

export const sendNfe = (userId, establishmentId, orderId) => dispatch => {
  dispatch(setIsModalLoading(true));

  return requestSendNfe(userId, establishmentId, orderId)
    .then(() => toast.success('Nota fiscal enviada com sucesso.'))
    .catch(error => {
      if(+error.response.data.data.code == '17001') {
        toast.error(error.response.data.data.msg);
      }
    })
    .finally(() => dispatch(setIsModalLoading(false)));
}